import React from 'react'

interface ContactUsProps {
  setViewMode: Function
}

const ContactUs: React.FunctionComponent<ContactUsProps> = (
  props: ContactUsProps,
) => {

  return (
    <>
      <div className='d-flex justify-content-center'>
        <iframe
          title='Support Form'
          className='text-center'
          width={650}
          height={550}
          src='../support.html'
        ></iframe>
      </div>
    </>
  )
}

export default ContactUs
